module.exports = __webpack_public_path__ + "img/tg-white.4a44004a.svg";